import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard } from '@backstage/core-components';
import { Button, Typography } from '@material-ui/core';

const POLICY_REPORTER_BASE_URL = 'https://policy.kyndemo.live';

/**
 * Card that links to the Policy Reporter UI filtered by the entity's namespace.
 * Shows policy compliance status link for workloads governed by Kyverno.
 */
export const PolicyReportCard = () => {
  const { entity } = useEntity();

  const namespace =
    entity.metadata.annotations?.['backstage.io/kubernetes-namespace'] ??
    entity.metadata.namespace ??
    'default';

  const policyReporterUrl = `${POLICY_REPORTER_BASE_URL}/#/namespace/${namespace}`;

  return (
    <InfoCard title="Policy Compliance" subheader="Kyverno PolicyReport">
      <Typography variant="body2" paragraph>
        View admission policy violations for namespace <strong>{namespace}</strong>,
        including Workload Identity (STD-0002) enforcement status.
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        href={policyReporterUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        View Policy Report
      </Button>
    </InfoCard>
  );
};
